import { FormattedMessage } from 'react-intl'
import React from 'react'
import MaintenanceBanner from '@berlitzplatforms/micro.ui.maintenance-banner'

const RestrictedLPBanner2B = () => {
  const refreshPage = () => window.location.reload()
  return (
    <MaintenanceBanner
      // header={
      //   <FormattedMessage
      //     id="Your next level isn't quite ready yet."
      //     defaultMessage="Your next level isn't quite ready yet."
      //   />
      // }
      subHeader={
        <FormattedMessage
          id="You will access your materials outside the MyBerlitz Portal"
          defaultMessage="You will access your materials outside the MyBerlitz Portal"
        />
      }
      btnText={<FormattedMessage id="Reload" defaultMessage="Reload" />}
      onButtonClick={refreshPage}
    />
  )
}

export default RestrictedLPBanner2B
